<my-bill-odb-page-base-structure
  [billingDocument]="billingDocument"
  [hasCommonHeader]="hasDataAvailable"
  [customTitle]="'bills.cover.identifierLabels.thirdParty' | translate"
>
  <!--///////////////   LEFT Column content   //////////////////-->
  <my-bill-odb-third-party-level-three
    leftColumnContent
    [billingAccount]="billingAccount"
    [billingDocument]="billingDocument"
    [customerId]="customerId"
    [customerSubsegment]="customerSubsegment"
    [customerGlobalId]="customerGlobalId"
    [customerMobile]="customerMobile"
    [productSplitIdentifier]="productSplit.identifier"
    [amount]="productSplit.amount"
    [openTransactionToPayIndex]="openTransactionToPayIndex"
    [categoryDetails]="productSplit.categoryDetails"
    *ngIf="hasDataAvailable && productSplit?.categoryDetails?.length > 0"
  ></my-bill-odb-third-party-level-three>
</my-bill-odb-page-base-structure>
